import './Page.css';

function CancerRehab() {
  return (
    <main className="page">
      <section className="page-content">
        <h1>What is Cancer Rehabilitation?</h1>
        <p>
          Cancer rehabilitation is a specialized medical service that helps people improve strength, mobility, and overall function during and after cancer treatment. Treatments such as chemotherapy, radiation, and surgery can lead to fatigue, weakness, nerve pain, limited movement, or difficulty with daily activities.
        </p>
        <p>
          A physician trained in Physical Medicine and Rehabilitation (PM&R), also known as a physiatrist, works with patients to manage these side effects through personalized, non-surgical care. The goal of cancer rehabilitation is to reduce pain, restore physical function, and help patients safely return to their daily routines and improve quality of life throughout the recovery process.
        </p>
      </section>
    </main>
  );
}

export default CancerRehab;
